export const massMessagingStatuses = [
  'created-status',
  'started-status',
  'completed-status',
  'cancelled-status',
  'on-hold-status',
  'waiting-for-quota',
];
